import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Icon from '../../components/AppIcon';
import FeatureCards from './components/FeatureCards';
import StatsSection from './components/StatsSection';
import HowItWorksSection from './components/HowItWorksSection';
import TestimonialsCarousel from './components/TestimonialsCarousel';
import InteractiveNetwork from './components/Carousel';

import HeaderSection from './components/HeroSection';

const HomeLandingPage = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const items = [
    {
      label: 'درباره ایران داد',
      bgColor: '#0D0716',
      textColor: '#fff',
      links: [
        { label: 'درباره ما', ariaLabel: 'درباره ما' },
        { label: 'فرصت‌های شغلی', ariaLabel: 'فرصت‌های شغلی' },
      ],
    },
    {
      label: 'قوانین و مقررات',
      bgColor: '#170D27',
      textColor: '#fff',
      links: [
        { label: 'خدمات', ariaLabel: 'خدمات' },
        { label: 'حریم خصوصی', ariaLabel: 'حریم خصوصی' },
      ],
    },
    {
      label: 'تماس با ما',
      bgColor: '#271E37',
      textColor: '#fff',
      links: [
        { label: 'تماس', ariaLabel: 'تماس با ما' },
        { label: 'شرایط استفاده', ariaLabel: 'شرایط استفاده' },
        // { label: 'LinkedIn', ariaLabel: 'LinkedIn' },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <HeaderSection
        logoAlt="Company Logo"
        items={items}
        baseColor="#fff"
        menuColor="#000"
        buttonBgColor="#111"
        buttonTextColor="#fff"
        ease="power3.out"
      />
      {/* Navigation Header
      <header className="fixed top-0 right-0 left-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">

            <div className="flex items-center space-x-reverse space-x-4">
              <Link
                to="/email-authentication-entry"
                className="inline-flex items-center px-4 py-2 text-sm font-medium text-ring hover:text-primary/80 transition-smooth focus-ring rounded-md">
                ورود
              </Link>
              <Link
                to="/email-authentication-entry"
                className="inline-flex items-center px-4 py-2 text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 transition-smooth focus-ring rounded-md">
                ثبت نام
              </Link>
            </div>

            <div className="flex items-center space-x-reverse space-x-4">
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 text-sm font-medium text-ring hover:text-primary/80 transition-smooth focus-ring rounded-md">
                دانشنامه
              </Link>
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 text-sm font-medium text-ring hover:text-primary/80 transition-smooth focus-ring rounded-md">
                لیست وکلا
              </Link>
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 text-sm font-medium text-ring hover:text-primary/80 transition-smooth focus-ring rounded-md">
                درباره ما
              </Link>
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 text-sm font-medium text-ring hover:text-primary/80 transition-smooth focus-ring rounded-md">
                لیست وکلا
              </Link>
            </div>
            {/* Logo (Right side in RTL)
            <Link
              to="/"
              className="flex items-center space-x-reverse space-x-3 focus-ring rounded-lg p-2">

              <div className="flex flex-col">
                <span className="text-xl font-bold text-foreground">
                  ایران داد
                </span>

              </div>
            </Link>
          </div>
        </div>
      </header> */}
      {/* Main Content */}
      <main className="pt-16">
        {/* Hero Section */}
        <InteractiveNetwork />

        {/* <HeroSection /> */}

        {/* Feature Cards */}
        <FeatureCards />

        {/* Stats Section */}
        <StatsSection />

        {/* How It Works */}
        <HowItWorksSection />

        {/* Testimonials */}
        <TestimonialsCarousel />

        {/* Call to Action Section */}
        <section className="py-16 bg-primary">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}>
              <h2 className="text-3xl font-bold text-primary-foreground mb-4">
                همین حالا شروع کنید
              </h2>
              <p className="text-lg text-primary-foreground/90 mb-8">
                اولین سوال حقوقی خود را بپرسید و تجربه مشاوره هوشمند را آغاز
                کنید
              </p>
              <Link
                to="/legal-consultation-chatbot"
                className="inline-flex items-center px-8 py-4 text-lg font-medium bg-white text-primary hover:bg-gray-100 transition-smooth focus-ring rounded-lg shadow-moderate">
                <Icon name="MessageSquare" size={24} className="ml-3" />
                شروع مشاوره رایگان
              </Link>
            </motion.div>
          </div>
        </section>
      </main>
      {/* Footer */}
      <footer className="bg-muted py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Logo and Description */}
            <div>
              <div className="flex items-center space-x-reverse space-x-3 mb-4">
                <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
                  <Icon name="Scale" size={20} color="white" />
                </div>
                <span className="text-lg font-semibold text-foreground">
                  ایران‌داد
                </span>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">
                ایران داد - پلتفرم هوشمند مشاوره حقوقی با استفاده از فناوری هوش
                مصنوعی
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-sm font-semibold text-foreground mb-4">
                دسترسی سریع
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/legal-consultation-chatbot"
                    className="text-sm text-muted-foreground hover:text-foreground transition-smooth">
                    چت‌بات حقوقی
                  </Link>
                </li>
                <li>
                  <Link
                    to="/email-authentication-entry"
                    className="text-sm text-muted-foreground hover:text-foreground transition-smooth">
                    ورود / ثبت نام
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-sm font-semibold text-foreground mb-4">
                تماس با ما
              </h3>
              <div className="space-y-2">
                <div className="flex items-center text-sm text-muted-foreground">
                  <Icon name="Mail" size={16} className="ml-2" />
                  info@irandaad.com
                </div>
                <div className="flex items-center text-sm text-muted-foreground">
                  <Icon name="Phone" size={16} className="ml-2" />
                  ۰۲۱-۱۲۳۴۵۶۷۸
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-border mt-8 pt-8 text-center">
            <p className="text-xs text-muted-foreground">
              © ۱۴۰۴ ایران داد. تمامی حقوق محفوظ است.
            </p>
          </div>
          <img
            referrerPolicy="origin"
            id="rgvjsizpapfurgvjoeukjxlz"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              window.open(
                'https://logo.samandehi.ir/Verify.aspx?id=395381&p=xlaopfvldshwxlaomcsirfth',
                'Popup',
                'toolbar=no,scrollbars=no,location=no,statusbar=no,menubar=no,resizable=0,width=450,height=630,top=30'
              )
            }
            alt="logo-samandehi"
            src="https://logo.samandehi.ir/logo.aspx?id=395381&p=qftibsiyujynqftiaqgwnbpd"
          />
        </div>
      </footer>
    </div>
  );
};

export default HomeLandingPage;
